import LoginSmsCodeStep from './Steps/LoginSmsCodeStep';
import LoginInitialStep from './Steps/LoginInitialStep';

export const steps = [
  {
    stepId: 1,
    Component: LoginInitialStep,
  },
  {
    stepId: 2,
    Component: LoginSmsCodeStep,
  },
];
